import { render, staticRenderFns } from "./InterviewDetails.vue?vue&type=template&id=97b1aae4&scoped=true"
import script from "./InterviewDetails.vue?vue&type=script&lang=js"
export * from "./InterviewDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97b1aae4",
  null
  
)

export default component.exports